import { useMutation } from '@apollo/client';
import type {
  UpdateHangingProtocolMutation,
  UpdateHangingProtocolMutationVariables,
} from 'generated/graphql';
import type { DefaultContext, FetchResult, MutationFunctionOptions } from '@apollo/client';

import { UPDATE_HANGING_PROTOCOL, GET_ALL_HANGING_PROTOCOLS } from 'modules/Apollo/queries';
import { WithApolloContext } from 'modules/Apollo/types';

export const useUpdateHangingProtocol = ({
  context,
}: WithApolloContext): ((
  options?: MutationFunctionOptions<
    UpdateHangingProtocolMutation,
    UpdateHangingProtocolMutationVariables,
    DefaultContext
  >
) => Promise<FetchResult<UpdateHangingProtocolMutation>>) => {
  const [updateHangingProtocol] = useMutation<
    UpdateHangingProtocolMutation,
    UpdateHangingProtocolMutationVariables
  >(UPDATE_HANGING_PROTOCOL, {
    refetchQueries: [{ query: GET_ALL_HANGING_PROTOCOLS }],
    awaitRefetchQueries: true,
    context,
  });
  return updateHangingProtocol;
};
